import { validateMailReward } from '@rb/shared/mail/reward-validation';
import type { MailReward } from '@rb/shared/mail/admin-send.types';

export interface RewardRow {
  key: string;
  amount: number;
  /**
   * 이 행을 "delivery key 직접 입력" 모드로 고정한다(결제 이벤트 티어 전용).
   *
   * 이 플래그가 없으면 피커는 "옵션에 없는 키" 라는 파생 조건으로만 커스텀 여부를
   * 판단하게 되는데, 그러면 사용자가 입력값을 전부 지운 순간 Select 로 되돌아가
   * 다시 커스텀으로 만들 방법이 없어진다. 메일 발송 경로(allowCustomKey 미전달)는
   * 이 필드를 절대 세우지 않으므로 payload 모양이 그대로 유지된다.
   */
  custom?: boolean;
}

export interface SerializeResult {
  ok: boolean;
  rewards: MailReward[];
  errors: string[];
}

/** 피커 행 배열을 검증·정규화. 빈 키 행은 무시, 무효 행은 errors 로 수집. */
export function serializeRewardRows(rows: RewardRow[]): SerializeResult {
  const rewards: MailReward[] = [];
  const errors: string[] = [];
  for (const row of rows) {
    if (!row.key) continue;
    const v = validateMailReward(row.key, row.amount);
    if (!v.ok) {
      errors.push(`${row.key}: ${v.reason}`);
      continue;
    }
    rewards.push({ key: v.key, amount: v.amount });
  }
  return { ok: errors.length === 0, rewards, errors };
}
